import React, { useState, useMemo } from "react";
import styles from "./feed.module.scss";
import FeedLightbox from "./feedLightbox";

export default function FeedAttachments({
  attachments = [],
  liteBoxHide = false
}) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Separate media & files
  const { media, files } = useMemo(() => {
    const media = [];
    const files = [];

    attachments.forEach((a) => {
      if (a?.type?.includes("image") || a?.type?.includes("video")) {
        media.push(a);
      } else {
        files.push(a);
      }
    });

    return { media, files };
  }, [attachments]);

  const count = media.length;

  // Clamp gallery layout to max 4
  const galleryCount = Math.min(count, 4);

  const galleryClass = [
    styles.gallery,
    styles[`gallery${galleryCount}`],
    count > 4 && styles.more
  ]
    .filter(Boolean)
    .join(" ");

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  return (
    <div>
      {/* MEDIA GRID */}
      {count > 0 && (
        <div className={galleryClass}>
          {media.slice(0, 4).map((file, idx) => {
            const isLast = idx === 3 && count > 4;

            return (
              <div
                key={file.uid || idx}
                className={styles.galleryItem}
                onClick={() => openLightbox(idx)}
              >
                {file.type?.includes("video") ? (
                  <video
                    src={file.url}
                    className={styles.galleryMedia}
                    muted
                    playsInline
                  />
                ) : (
                  <img
                    src={file.url}
                    alt={file.name || "attachment"}
                    className={styles.galleryMedia}
                    loading="lazy"
                  />
                )}

                {isLast && (
                  <div className={styles.moreOverlay}>
                    +{count - 4}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* FILE ATTACHMENTS */}
      {files.length > 0 && (
        <div className={styles.fileSection}>
          {files.map((f, idx) => (
            <a
              key={f.uid || idx}
              href={f.url}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.fileCard}
            >
              <span>{f.name}</span>
            </a>
          ))}
        </div>
      )}

      {/* LIGHTBOX */}
      {!liteBoxHide && (
        <FeedLightbox
          media={media}
          index={currentIndex}
          open={lightboxOpen}
          onClose={() => setLightboxOpen(false)}
          setIndex={setCurrentIndex}
        />
      )}
    </div>
  );
}
